const loadingLabel = "Hämtar";
const svSE = {
  loadingLabel
};
export {
  svSE as default,
  loadingLabel
};
